export default __webpack_public_path__ + "static/media/eighth.12617a76.jpeg";